import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { SessionHistoryChallenge } from "../SessionHistoryChallenge";
import styled from "styled-components";

export const SummaryDeprecated = ({
  value,
  challengeData,
  challengeDataErrors,
  isChallengeDataLoading,
  fetchChallengeData,
  setChallengeDataErrors,
  index,
  currentQuestionIndex,
  setCurrentQuestionIndex,
  showQuestionCard = true,
  reportLocation,
}) => {
  const challenges = challengeData?.[value?.session_id];
  const hasChallenges = challenges?.length > 0;

  return (
    <SummaryWrapper>
      {/* {value.summary_text ? ( */}
      {/*   <> */}
      {/*     <Text> */}
      {/*       {value?.summary_text} */}
      {/*     </Text> */}
      {/*   </> */}
      {/* ) : ( */}
      {/*   <Subtitle>Session summary not yet available.</Subtitle> */}
      {/* )} */}

      <Container>
        {isChallengeDataLoading?.[index] ? (
          <Loading>
            <FontAwesomeIcon icon={faSpinner} spin size="3x" />
          </Loading>
        ) : hasChallenges ? (
          // The card renders the session's own activity. A caller that cannot
          // say which activity it was says so rather than being handed a
          // question rendered as the wrong one.
          showQuestionCard ? (
            <SessionHistoryChallenge
              value={value}
              challengeDetails={challenges}
              currentQuestionIndex={currentQuestionIndex}
              setCurrentQuestionIndex={setCurrentQuestionIndex}
              reportLocation={reportLocation}
            />
          ) : null
        ) : challengeDataErrors?.[value?.session_id] ? (
          <div>
            <strong>Error:</strong> {challengeDataErrors[value.session_id]}
            <ButtonWrapper>
              <Button
                onClick={(e) => {
                  e.stopPropagation();
                  setChallengeDataErrors(prev => {
                    const newErrors = { ...prev };
                    delete newErrors[value.session_id];
                    return newErrors;
                  });
                  fetchChallengeData(value.session_id, index);
                }}
              >
                Try Again
              </Button>
            </ButtonWrapper>
          </div>
        ) : (
          <div style={{ fontStyle: "italic" }}>This session did not have any challenges.</div>
        )}
      </Container>
    </SummaryWrapper>
  )
}

const ButtonWrapper = styled.div`
  margin-top: 0.625rem;
`

const Button = styled.button`
  background-color: #fff;
  border: 1px solid #dc3545;
  border-radius: .25rem;
  color: #dc3545;
  cursor: pointer;
  padding: .3125rem .625rem;
`

const Loading = styled.div`
  display: flex;
  justify-content: center;
  padding: 1.25rem;
`

const SummaryWrapper = styled.div`
  margin: 1.5rem 0;
`

const Text = styled.p`
  white-space: pre-wrap;
`

const Subtitle = styled.p`
  display: flex;
  justify-content: center;
  padding: 1.25rem; 
`

const Container = styled.div`
  margin-top: 1.25rem;
`
